import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  LastDealsTableColumn,
  LastDealsTableColumnId,
  LastDealsTableSorting,
} from '@prlw/core/deals/types/last-deals.types';

@Component({
  selector: 'prlw-last-deals-table-header-row-ui',
  templateUrl: './last-deals-table-header-row.component.html',
  styleUrl: './last-deals-table-header-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastDealsTableHeaderRowComponent {
  @Input() public showContent: boolean | null = true;
  @Input() public columns: LastDealsTableColumn[] | null = null;
  @Input() public sorting: LastDealsTableSorting | null = null;
  @Input() public gridSize: string | null = null;

  @Output() public readonly sortColumn =
    new EventEmitter<LastDealsTableColumnId>();
}
